import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.fehlerbeschreibung-hinzufuegen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFehlerbeschreibungHinzufuegenEffects {

    FehlerbeschreibungHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FEHLERBESCHREIBUNG_HINZUFUEGEN),
        mergeMap((x: ac.PostFehlerbeschreibungHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFehlerbeschreibungHinzufuegen(x.aufgabeFehlerbeschreibungRequest).pipe(
                map((result: any) => {
                    return new ac.PostFehlerbeschreibungHinzufuegenErfolgreichAction(x.aufgabeFehlerbeschreibungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFehlerbeschreibungHinzufuegenFehlerAction(error, x.aufgabeFehlerbeschreibungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FehlerCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FehlerCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FehlerCommandService);
        }
        return this.service;
    }
}
